<template>
  <div class="site-info">
    <div class="section site-info-container">
      <div class="site-info-title">
        <div class="info-title">站点信息：{{ siteInfo.stationName }}</div>
        <view class="operation-container">
          <el-icon class="setIcon" @click="selectSetDialog = true">
            <Setting />
          </el-icon>
          <img v-show="!screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/screenIcon.png" @click="enterScreenClick" />
          <img v-show="screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/screenIcon.png" @click="exitFullscreenClick" />
        </view>
      </div>
      <div class="site-info-content">
        <div class="img">
          <img src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/templateImg1.png" alt="" style="width: 100%; height: 100%" />
        </div>
        <div class="info-container">
          <div class="info-list">
            <div
              class="info-list-item"
              v-for="(item, i) in siteInfoDataList"
              :key="i"
              :style="{
                marginBottom: i + 1 == siteInfoDataList.length || i == siteInfoDataList.length - 2 ? 0 : '32px',
              }"
            >
              <el-image :src="item.icon" style="width: 32px; height: 32px"></el-image>
              <div class="item-info">
                <div class="item-name">{{ item.name }}</div>
                <div class="item-value">
                  {{ item.value }} <span class="unit">{{ item.unit }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="map-container">
          <mapChange ref="mapChangeRef" :longitude="siteInfo.longitude" :latitude="siteInfo.latitude" :change-flag="false" map-height="100%"></mapChange>
        </div>
      </div>
    </div>
    <div class="section alarm-event-container">
      <div class="alarm-title">告警事件</div>
      <!-- <div class="tabs">
        <el-tabs v-model="tabsActiveName" class="demo-tabs" @tab-click="tabClick">
          <el-tab-pane label="User" name="first"></el-tab-pane>
          <el-tab-pane label="Config" name="second"></el-tab-pane>
          <el-tab-pane label="Role" name="third"></el-tab-pane>
        </el-tabs> -->
      <!-- </div> -->
      <div class="content-wrap" v-if="alarmMessageDataList && alarmMessageDataList.length > 0">
        <div class="strategyBox">
          <div class="titleBox">
            <div class="trBox">
              <div class="thBox">告警设备</div>
              <div class="thBox">告警等级</div>
              <div class="thBox">发生时间</div>
              <div class="thBox">事件</div>
            </div>
          </div>
          <div class="contentBox">
            <div v-for="(item, i) in alarmMessageDataList" :key="i" class="trBox" :class="{ 'animate-up': animateUp }">
              <div class="tdBox">{{ item.equipmentName }}</div>
              <div :title="item.controlName" class="tdBox">
                {{ item.levelStr }}
              </div>
              <div :title="item.executeTime" class="tdBox">
                {{ item.time }}
              </div>
              <div class="tdBox">{{ item.triggerRule }}</div>
            </div>
          </div>
        </div>
      </div>
      <el-empty description="系统运行正常" v-else></el-empty>
    </div>

    <el-dialog v-model="selectSetDialog" class="selectSetDialog" title="污水监测配置" width="60%">
      <div class="list">
        <div class="list-item" v-for="(item, i) in configOptionList" :key="i" @click="openConfigDialog(item.refName)">
          <el-image :src="item.img"></el-image>
        </div>
      </div>
    </el-dialog>
    <siteConfigDialog ref="SiteConfigDialog" @submit="getSiteInfo"></siteConfigDialog>
    <electricalParametersConfigDialog ref="ElectricalParametersConfigDialog"></electricalParametersConfigDialog>
  </div>
</template>

<script setup>
import { ref, onMounted, inject, nextTick, watch } from "vue";
import useFullscreen from "@/hooks/useFullscreen";
import siteConfigDialog from "./site-config-dialog.vue";
import electricalParametersConfigDialog from "./electrical-parameters-config-dialog.vue";
import mapChange from "../../map-change.vue";
const mapChangeRef = ref(null);
import { getKanbanDataApiV2, getSewageWarnList } from "@/api/modules/project";

const receiveTemplateId = inject("templateId");
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21
const { screenFlag, enterScreenClick, exitFullscreenClick, triggerResize } = useFullscreen(".templatePage8");
let selectSetDialog = ref(false);
let configOptionList = ref([
  { img: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/wushui-template-config-1.png", refName: "SiteConfigDialog" },
  { img: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/projectTemplate/wushui-template-config-2.png", refName: "ElectricalParametersConfigDialog" },
]);
const SiteConfigDialog = ref(null);
const siteInfo = ref({
  stationName: "",
  longitude: "",
  latitude: "",
});
const getSiteInfo = function () {
  console.log("getSiteInfo", siteInfo.value);
  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockName: "sewageBaseInfo" };
  getKanbanDataApiV2(params).then((res) => {
    if (res.data.code == 200) {
      if (!res.data.data.sewageBaseInfo) return;
      siteInfo.value = res.data.data.sewageBaseInfo;
      console.log("siteInfo", siteInfo.value);
      nextTick(() => {
        mapChangeRef.value?.updateLocation();
      });
    }
  });
};
const ElectricalParametersConfigDialog = ref(null);
const componentRefs = {
  SiteConfigDialog,
  ElectricalParametersConfigDialog,
};
let alarmMessageDataList = ref([]);
const getWarnLogList = () => {
  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockName: "sewageWarnLogList" };
  getSewageWarnList(params).then((res) => {
    if (res.data.code == 200) {
      if (!res.data.data) return;
      alarmMessageDataList.value = res.data.data.filter((item) => {
        return item.level != 5;
      });
    }
  });
};

// 站点信息数据
let siteInfoDataList = ref([
  {
    name: "当前用电量",
    value: 0,
    key: "dayElectric",
    unit: "kwh",
    icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/icon-dqydl.png",
  },
  {
    name: "总用电量",
    value: 0,
    key: "totalElectric",
    unit: "kwh",
    icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/icon-zydl.png",
  },
  {
    name: "功率",
    value: 0,
    key: "power",
    unit: "w",
    icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/icon-gl.png",
  },
  {
    name: "温度",
    value: 0,
    key: "temperature",
    unit: "℃",
    icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/icon-wd.png",
  },
  {
    name: "电流",
    value: 0,
    key: "current",
    unit: "A",
    icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/icon-dl.png",
  },
  {
    name: "电压",
    value: 0,
    key: "voltage",
    unit: "V",
    icon: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/icon-dy.png",
  },
]);
// 站点信息
const getSiteInfoDataList = () => {
  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockName: "sewageStationInfo" };
  getKanbanDataApiV2(params).then((res) => {
    if (res.data.code == 200) {
      if (!res.data.data.sewageStationInfo) return;
      siteInfoDataList.value.forEach((item) => {
        item.value = res.data.data.sewageStationInfo ? res.data.data.sewageStationInfo[item.key] : 0;
      });
    }
  });
};

let tabsActiveName = ref("first");

let animateUp = ref(false);
const scrollAnimate = function () {
  animateUp.value = true;
  setTimeout(() => {
    if (alarmMessageDataList.value && alarmMessageDataList.value.length > 0) {
      alarmMessageDataList.value.push(alarmMessageDataList.value[0]);
      alarmMessageDataList.value.shift();
      animateUp.value = false;
    }
  }, 500);
};
const lunbo = function () {
  setInterval(scrollAnimate, 4000);
};
const openConfigDialog = function (refName) {
  console.log("当前 refName:", refName);
  console.log("componentRefs 所有引用:", componentRefs);
  console.log("对应引用的值:", componentRefs[refName]?.value);
  const dialgComponent = componentRefs[refName]?.value;
  console.log(dialgComponent);
  if (dialgComponent) {
    dialgComponent.openDialog();
  }
};

const tabClick = (tab, event) => {
  console.log(tab, event);
};

watch(
  () => receiveProjectModuleId.value,
  (val) => {
    if (val) {
      getSiteInfo();
      getSiteInfoDataList();
      getWarnLogList();
    }
  }
);

onMounted(() => {
  lunbo();
  getSiteInfo();
  getSiteInfoDataList();
  getWarnLogList();
});
</script>

<style lang="scss" scoped>
.site-info {
  display: flex;
  gap: 10px;
  height: 300px;
  box-sizing: border-box;
}
.site-info-container {
  flex: 1;
  // width: 90% !important;
  .site-info-title {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    .operation-container {
      display: flex;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
        margin-left: 10px;
      }
      .setIcon {
        margin-left: 10px;
        font-size: 18px;
        color: #165dff;
        cursor: pointer;
      }
    }
  }
  .site-info-content {
    .img {
      width: 185px;
      height: 185px;
      padding-right: 16px;
    }
    // padding-left: 197px;
    display: flex;
    .info-container {
      flex: 3;
      display: flex;
      align-items: center;
      justify-content: center;
      .info-list {
        display: flex;
        flex-wrap: wrap;
        .info-list-item {
          width: 50%;
          display: flex;
          align-items: center;
          padding: 0 16px;
          box-sizing: border-box;
          // justify-content: center;
          .item-info {
            margin-left: 10px;
            .item-name {
              font-size: 12px;
              color: #666666;
              line-height: 12px;
            }
            .item-value {
              font-weight: 600;
              font-size: 16px;
              color: #333333;
              line-height: 16px;
              margin-top: 10px;
              .unit {
                font-size: 12px;
                color: #999999;
              }
            }
          }
        }
      }
    }

    .map-container {
      flex: 2;
      // width: 230px;
      height: 230px;
      display: flex;
      border-radius: 10px;
      box-shadow: 0px 2px 5px 0px rgba(231, 8, 8, 0.09);
    }
  }
}
.alarm-event-container {
  width: 33%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .content-wrap {
    flex: 1;
    overflow: hidden;
  }
  .strategyBox {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .contentBox {
      flex: 1;
    }
    .titleBox {
      height: 40x;
      background: #f2f3f5;
      .trBox {
        height: 40x !important;

        .thBox {
          line-height: 25px;
        }
      }
    }
    .titleBox,
    .contentBox {
      overflow: hidden;

      .trBox {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .thBox,
        .tdBox {
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 500;
          font-size: 14px;
          color: #1d2129;
        }

        .thBox:nth-child(1),
        .tdBox:nth-child(1) {
          width: 18%;
          text-align: left;
        }

        .thBox:nth-child(2),
        .thBox:nth-child(3),
        .tdBox:nth-child(2),
        .tdBox:nth-child(3) {
          width: 18%;
        }

        .thBox:nth-child(4),
        .tdBox:nth-child(4) {
          flex: 1;
          padding-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
        .tdBox {
          font-size: 12px;
          color: #1d2129;
          line-height: 12px;
        }
      }

      .animate-up {
        transition: all 0.5s ease-in-out;
        transform: translateY(-40px);
      }
    }
    .contentBox {
      .trBox {
        border-bottom: 1px solid #e5e6eb;
      }
    }
  }
  ::v-deep .el-tabs__item {
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
  }
}
.selectSetDialog {
  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 16px;
    box-sizing: border-box;
    .list-item {
      width: calc(33% - 16px);
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #efefef;
      cursor: pointer;
      img {
        width: 100%;
        height: auto;
        border-radius: 4px;
      }
    }
  }
}
.section {
  background: #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.09);
  border-radius: 6px;
  padding: 16px;
  .title {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    line-height: 22px;
  }
}
</style>
